/** Generate a client-side correlation ID without creating a client OTel span. */
export function createRequestId(): string {
  const cryptoApi = typeof globalThis !== 'undefined' ? globalThis.crypto : undefined;
  if (cryptoApi?.randomUUID) return cryptoApi.randomUUID();

  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 14)}`;
}

/** Normalize caller headers so mixed-case duplicates cannot be emitted. */
export function withRequestId(headers: HeadersInit = {}): Record<string, string> {
  const normalized: Record<string, string> = {};
  let requestId: string | undefined;

  const entries: Array<[string, string]> = Array.isArray(headers)
    ? headers.map(([key, value]) => [key, value])
    : headers instanceof Headers
      ? Array.from(headers.entries())
      : Object.entries(headers);

  for (const [key, value] of entries) {
    if (key.toLowerCase() === 'x-request-id') {
      // A Headers object joins duplicate values with a comma. Keep only the
      // first caller value; emitting multiple correlation IDs is ambiguous.
      requestId ??= value.split(',')[0].trim();
    } else {
      normalized[key] = value;
    }
  }

  normalized['X-Request-Id'] = requestId || createRequestId();
  return normalized;
}
